export function miniAnswers(module, state, sections) {
  if (module === 'Writing') return { text: state.answers?.[0] || '' };
  if (module === 'Speaking') {
    const urls = state.audioState?.audioURLs || state.answers || {};
    return { recordings: sections.flatMap(section => section.questions || [])
      .map((question, index) => ({ questionId: question.id, audioUrl: urls[index] }))
      .filter(recording => recording.audioUrl && !recording.audioUrl.startsWith('blob:')) };
  }
  return state.answers || {};
}

export function miniDraftState(module, answers, sections) {
  if (module === 'Writing') return { answers: [answers?.text || ''] };
  if (module === 'Speaking') {
    const urls = {};
    sections.flatMap(section => section.questions || []).forEach((question, index) => {
      const recording = answers?.recordings?.find(item => String(item.questionId) === String(question.id));
      if (recording?.audioUrl) urls[index] = recording.audioUrl;
    });
    return { answers: urls, audioState: { audioURLs: urls } };
  }
  return { answers: answers || {} };
}
